<template>
	<div id="filters">
		<div id="search-container">
			<v-text-field
				v-model="searchFile"
				id="project-tree-search-input"
                append-icon="search"
				label="Search Assets"
				dark
				flat
				solo-inverted
				hide-details
				clearable
				clear-icon="mdi-close-circle-outline"
				@input="enteringSearch"
			/>

			<i
				@click="expandFilters = !expandFilters"
				id="btn-expand-filters"
				:class="{ '--applied': filtersList.length > 0 }"
				class="material-icons"
				content="Filters"
				v-tippy="{ placement: 'top-end', boundary: 'window' }"
				>filter_list</i
			>
		</div>

		<v-expand-transition>
			<div id="filters-list-outer-container" v-show="expandFilters">
				<div id="filters-list-container">
					<component
						v-for="(filter, index) in filtersList"
						:key="filter.id"
						:filter-index="index"
						:filter-id="filter.id"
						:is="filter.component"
						@deleted="remove"
					></component>
					<button @click="add" id="btn-add-filter"><i class="material-icons">add</i>Add filter</button>
				</div>
			</div>
		</v-expand-transition>
	</div>
</template>

<script>
import { generateUniqueId } from '@/assets/js/Utilities';
import ProjectTreeFilterTemplate from "@/components/app/project-tree/ProjectTreeFilterTemplate";

export default {
	data() {
		return {
			filtersList: [],
			expandFilters: false,
			searchFile: null,
		};
	},
	methods: {
		enteringSearch() {
			this.$store.dispatch("Projects/updateProjectTreeSearch", this.searchFile);
			this.$store.dispatch("Projects/updateLastOpenProjectTree", this.$parent.$refs.projectTree);
		},
		add() {
			this.filtersList.push({
				id: generateUniqueId(),
				component: ProjectTreeFilterTemplate,
			});
		},
		remove(id) {
			this.filtersList = this.filtersList.filter(filter => filter.id !== id);
		},
	},
};
</script>

<style lang="scss">
#filters {
	margin-bottom: 10px;

	#search-container {
		display: flex;
		justify-content: space-between;
		align-items: center;

        // search field
        > .v-text-field {
            .v-input__slot {
                padding: 0 12px 0 20px;
            }
        }
	}

	// search field & filters
	.v-text-field {
        border: 1px solid var(--font-default-color);
        border-radius: 25px;

		.v-input__slot {
			background: transparent;
            padding: 0;

			.v-label {
				font-size: 1rem;
				font-weight: normal;
				color: var(--font-default-color);
			}
		}

		.v-input__icon--prepend-inner i {
			color: var(--font-default-color);
		}

		.v-input__append-inner {
			.v-icon::before {
				font-size: 18px;
				color: var(--font-default-color);
			}
		}

        .v-input__control {
            min-height: initial;
        }
	}

	#project-tree-search-input {
		color: #fff;
		font-size: 1rem;
		font-weight: normal;
	}

	#filters-list-container {
		// margin-top: 10px;
		background: var(--modal-bg);
		border-radius: var(--box-rounding);
		padding: 15px 7px;

		.filter-container {
            display: grid;
            grid-template-columns: auto minmax(0, min-content) minmax(0, min-content) minmax(0, min-content);
			justify-content: start;
			align-items: center;
			margin-bottom: 7px;
			width: 100%;

			.btn-remove-filter {
				font-size: 18px;
				margin-right: 7px;
			}

			.v-input {
				margin-top: 0;
				padding: 2px 2px 2px 7px;
				flex: initial;
				//max-width: calc((100% - 18px) / 3);
				// flex-basis: 25%;
				// flex-grow: 1;
				// min-width: 100%;
				&:not(:last-of-type) {
					margin-right: 5px;
				}

				border: 1px solid var(--font-default-color);
				border-radius: 7px;
				&.v-select {
					input {
						display: none;
						// position: absolute;
						// height: 10px;
					}
				}

				// date picker
				input {
					color: var(--font-default-color);
					font-size: 0.9rem;
					height: 18px;
					text-overflow: ellipsis;
					white-space: nowrap;
					width: 100%;
					overflow: hidden;
				}
			}

			.v-input__control {
				min-height: initial;
			}

			.v-select__selection {
				color: var(--font-default-color);
				font-size: 0.9rem;
				margin: 0;
				line-height: 1.2;
				overflow: hidden !important;
				min-width: 100%;
				margin-top: 2px;
			}
			.v-select__selections {
				flex: initial;
				.filter-select-items-contaner {
					display: flex;
					align-items: center;
					overflow: hidden !important;
					min-width: 100%;
					color: var(--font-default-color);
					.filter-value-label {
						font-size: 0.9rem;
						line-height: 1;
						text-overflow: ellipsis;
						white-space: nowrap;
						overflow: hidden;
						margin-top: 2px;
					}
					i {
						width: 18px;
					}
					i + .filter-value-label {
						margin-left: 2px;
					}
				}
			}
			.v-text-field__details {
				display: none;
			}
			.v-input__slot {
				margin-bottom: 0;
				&:before,
				&:after {
					display: none;
				}
			}
			.v-input__append-inner {
				margin: initial;
				padding: initial;
				.v-input__icon--append {
					min-width: initial;
					width: initial;
					height: initial;
				}
			}
		}
	}

	#btn-add-filter {
		display: flex;
		align-items: center;

		// margin-bottom: 20px;
		> i {
			margin-right: 7px;
		}
	}

	#btn-expand-filters {
		margin-left: 7px;
		&.--applied {
			color: var(--primary);
		}
	}
}

#filters-list-outer-container {
	margin-top: 20px;
}

.filter-menu-container {
	.v-select-list {
		background: #282828;
		.v-list-item {
			min-height: 2rem;
			&:hover {
				background: #363636;
			}
			&.v-list-item--active {
				background: #363636;
				&::before {
					display: none;
				}
			}
			.filter-select-items-contaner {
				display: flex;
				align-items: center;
				i {
					font-size: 18px;
					width: 18px;
					color: var(--font-default-color);
				}
				span {
					font-size: 0.9rem;
					color: var(--font-default-color);
				}
				i + span {
					margin-left: 2px;
					margin-top: 2px;
				}
			}
		}
	}

	.v-picker--date {
		background: #363636;
		.v-picker__title {
			background: var(--primary) !important;
			.v-date-picker-title__date > div {
				line-height: 1;
				font-size: 14px;
			}
		}

		.v-picker__body {
			background: #363636;
			th {
				color: var(--primary);
			}
			.v-btn {
				&.v-btn--active {
					.v-btn__content {
						color: white;
					}
					&:before {
						background: var(--primary);
						opacity: 1;
					}
				}

				&.v-date-picker-table__current {
					color: var(--primary) !important;
				}

				&.v-btn--disabled {
					opacity: 0.3;
				}

				.v-btn__content {
					color: var(--font-default-color);
				}
			}

			.v-date-picker-header__value button {
				color: var(--font-default-color) !important;
			}

			.v-date-picker-years {
				color: var(--font-default-color);
				font-size: 1rem;

				> .active {
					color: var(--primary);
					font-size: 14px;
					font-weight: bold;
				}
			}
		}
	}
}
</style>
